import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import dayjs from 'dayjs';
import { t } from 'ember-intl';
import GeneralFormsFormFieldsDatepickerFormField from 'lumen/components/general/forms/form-fields/datepicker-form-field';

interface HotelAndMarketRatesExportModalCustomExportDateRangePickerSignature {
  Args: {
    endDate: unknown;
    endDateMoment: unknown;
    endSelection: unknown;
    liveupdateChecked: unknown;
    params: unknown;
    startDate: unknown;
    startDateMoment: unknown;
    startSelection: unknown;
  };
}

export default class HotelAndMarketRatesExportModalCustomExportDateRangePicker extends Component<HotelAndMarketRatesExportModalCustomExportDateRangePickerSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get days() {
    if (this.args.startDate && this.args.endDate) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return this.args.endDateMoment.diff(this.args.startDateMoment, 'day');
    }
    return 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get disableExport() {
    const startDateIsFilled = this.args.startDate;
    const endDateIsFilled = this.args.endDate;

    return !startDateIsFilled || !endDateIsFilled;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get localEndDate() {
    if (this.args.endDate) {
      // @ts-expect-error: Incorrect type
      return this.hotelAndMarketService.toLocalTime(this.args.endDate);
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get localStartDate() {
    if (this.args.startDate) {
      // @ts-expect-error: Incorrect type
      return this.hotelAndMarketService.toLocalTime(this.args.startDate);
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get maxEndDate() {
    if (!this.args.startDate) {
      return this.hotelAndMarketService.ratesDataEnd;
    }

    const isRatesDataEndBeforeMaxInterval =
      this.hotelAndMarketService.ratesDataEnd?.isBefore(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.localStartDate.add(this.args.params?.maxInterval ?? 365, 'day'),
      );

    if (isRatesDataEndBeforeMaxInterval) {
      return this.hotelAndMarketService.ratesDataEnd;
    }

    // @ts-expect-error: Incorrect type
    return dayjs(this.args.startDate).add(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.args.params?.maxInterval ?? 365,
      'day',
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get maxStartDate() {
    return this.localEndDate ?? this.hotelAndMarketService.ratesDataEnd;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get minEndDate() {
    let minEndDateMoment = this.hotelAndMarketService.ratesDataStart;

    if (this.args.startDate) {
      // @ts-expect-error: Incorrect type
      minEndDateMoment = this.localStartDate;
    }

    if (
      this.args.liveupdateChecked &&
      minEndDateMoment.isBefore(this.hotelAndMarketService.getLocalTime())
    ) {
      minEndDateMoment = this.hotelAndMarketService.getLocalTime();
    }

    return minEndDateMoment;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get minStartDate() {
    let minStartDateMoment = this.hotelAndMarketService.ratesDataStart;

    if (
      this.args.liveupdateChecked &&
      minStartDateMoment.isBefore(this.hotelAndMarketService.getLocalTime())
    ) {
      minStartDateMoment = this.hotelAndMarketService.getLocalTime();
    }

    if (
      this.args.endDate &&
      // @ts-expect-error: Incorrect type
      minStartDateMoment.isBefore(this.localEndDate.subtract(365, 'day'))
    ) {
      // @ts-expect-error: Incorrect type
      minStartDateMoment = this.localEndDate.subtract(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.args.params?.maxInterval,
        'day',
      );
    }

    return minStartDateMoment;
  }

  <template>
    <div class="flex gap-400">
      <div class="w-1/2">
        <GeneralFormsFormFieldsDatepickerFormField
          {{! @glint-expect-error: Incorrect type }}
          @datePickerMaxDate={{this.maxStartDate}}
          @datePickerMinDate={{this.minStartDate}}
          @label={{t "events.start_date"}}
          @onSelectDate={{@startSelection}}
          @removePadding={{true}}
          @selectedDate={{@startDate}}
        />
      </div>
      <div class="w-1/2">
        <GeneralFormsFormFieldsDatepickerFormField
          {{! @glint-expect-error: Incorrect type }}
          @datePickerMaxDate={{this.maxEndDate}}
          @datePickerMinDate={{this.minEndDate}}
          @label={{t "events.end_date"}}
          @onSelectDate={{@endSelection}}
          @removePadding={{true}}
          @selectedDate={{@endDate}}
        />
      </div>
    </div>
  </template>
}
